import { DateTime } from "luxon";

export const DATE_TIME_FORMAT = "fff";
export function formatDateTime(millis: number): string {
  return DateTime.fromMillis(millis).toFormat("fff");
}

export function formatDate(millis: number): string {
  return DateTime.fromMillis(millis).toFormat("D");
}

export function formatShortTime(time: string): string {
  const dateTime = DateTime.fromFormat(time, "HH:mm:ss");
  if (dateTime.minute > 0) {
    return dateTime.toFormat("h:mma");
  }

  return dateTime.toFormat("ha");
}

export function timezoneDisplayName(timezone: string): string {
  return DateTime.local().setZone(timezone).offsetNameShort ?? timezone;
}

export function formatShortDateTime(millis: number): string {
  return DateTime.fromMillis(millis).toFormat("D t ZZZZ");
}
